import React from 'react';
import {isString} from 'lodash';
import {
  removeAllTokens,
  removeWfTokens,
} from '@packages/systems/core/utils/EmbedUtils/all';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {Atom, AtomRenderProps} from '@packages/systems/wfdl';
import {TRecord, TText, TBoolean} from '@packages/systems/wfdl-ast';
import {
  EvaluatedNodeData,
  getBoolean,
  getInPojo,
  getStringOrElse,
} from '@packages/utilities/data-utils';
import {useRuntimeEnvironment} from '@packages/systems/render';

const getStaticCustomCodeValue = (
  data: EvaluatedNodeData,
  exportMode: boolean
) => {
  const value = getStringOrElse(getInPojo(data, ['value']), '');
  return !exportMode && getBoolean(getInPojo(data, ['shouldReplaceTokens']))
    ? removeAllTokens(value)
    : removeWfTokens(value || '');
};

const CustomCode = Atom.createRender(({data, token}: AtomRenderProps) => {
  const runtimeEnvironment = useRuntimeEnvironment();
  const exportMode = runtimeEnvironment === WebflowEnvironments.EXPORT;
  const value = isString(token)
    ? token
    : getStaticCustomCodeValue(data, exportMode);
  return value ? (
    // @ts-expect-error - TS2339 - Property 'wf-custom-code' does not exist on type 'JSX.IntrinsicElements'.
    <wf-custom-code
      dangerouslySetInnerHTML={{
        __html: value,
      }}
    />
  ) : null;
});

const config = Atom.create({
  showEmpty: false,
  render: CustomCode,
  dataType: TRecord({value: TText, shouldReplaceTokens: TBoolean}),
});

export default config;
